import { useAuth0 } from "@auth0/auth0-react"
import { Box, Button, Group, NumberInput } from "@mantine/core"
import { useForm } from "@mantine/form"
import React, { useContext } from "react"
import UserDetails from "../../context/UserDetails"
import useProperties from "../../hooks/useProperties"
import { useMutation } from "react-query"
import { toast } from "react-toastify"
import { createResidency } from "../../utils/api"

const Facilities = ({
  propertyDetails,
  setPropertyDetails,
  prevStep,
  setOpened,
  setActiveStep,
}) => {
  const form = useForm({
    initialValues: {
      bedrooms: propertyDetails.bedrooms,
      parkings: propertyDetails.parkings,
      bathrooms: propertyDetails.bathrooms,
    },
    validate: {
      bedrooms: (value) => (value < 1 ? "Must have atleast 1 room" : null),
      bathrooms: (value) => (value < 1 ? "Must have atleast 1 bathroom" : null),
    },
  })

  const { bedrooms, parkings, bathrooms } = form.values

  const handleSubmit = () => {
    const { hasErrors } = form.validate()
    if (!hasErrors) {
      setPropertyDetails((prev) => ({
        ...prev,
        facilities: { bedrooms, parkings, bathrooms },
      }))
      mutate()
    }
  }

  const { user } = useAuth0()
  const {
    userDetails: { token },
  } = useContext(UserDetails)
  const { refetch: refetchProperties } = useProperties()

  const { mutate, isLoading } = useMutation({
    mutationFn: () =>
      createResidency(
        {
          ...propertyDetails,
          facilities: { bedrooms, parkings, bathrooms },
        },
        token
      ),
    onError: ({ response }) =>
      toast.error(response.data.message, { position: "bottom-right" }),
    onSettled: () => {
      toast.success("Added Successfully", { position: "bottom-right" })
      setPropertyDetails({
        title: "",
        description: "",
        price: 0,
        country: "",
        city: "",
        address: "",
        image: null,
        facilities: {
          bedrooms: 0,
          parkings: 0,
          bathrooms: 0,
        },
        userEmail: user?.email,
      })
      setOpened(false)
      setActiveStep(0)
      refetchProperties()
    },
  })

  return (
    <Box maw="30%" mx="auto" my="sm">
      <form
        onSubmit={(e) => {
          e.preventDefault()
          handleSubmit()
        }}
      >
        <NumberInput
          withAsterisk
          label="No of bedrooms"
          min={0}
          {...form.getInputProps("bedrooms")}
        />
        <NumberInput
          withAsterisk
          label="No of parkings"
          min={0}
          {...form.getInputProps("parkings")}
        />
        <NumberInput
          withAsterisk
          label="No of bathrooms"
          min={0}
          {...form.getInputProps("bathrooms")}
        />
        <Group position="center" mt={"xl"}>
          <Button variant="default" onClick={prevStep}>
            Back
          </Button>
          <Button type="submit" color="green" disabled={isLoading}>
            {isLoading ? "Submitting" : "Add Property"}
          </Button>
        </Group>
      </form>
    </Box>
  )
}

export default Facilities
